export default __webpack_public_path__ + "static/image-71-34f988f503026bf4fba0557d53c64e79.jpg";